import { forwardRef } from "react";
import styled from "styled-components/macro";
import Button, { ButtonElement } from "ui/Button";
import BackIcon from "ui/Icons/Back";
import ReplayIcon from "ui/Icons/Replay";
import ForwardArrowIcon from "ui/Icons/ForwardArrow";
import {
  SurfaceType,
  AnalyticsProperties,
} from "utils/analytics/analyticsConstants";

const $Wrapper = styled(Button).attrs({
  requestInProgress: false,
})`
  border-radius: 50%;
  min-height: 3rem;
  padding: 0;
  width: 3rem;

  path {
    fill: currentColor;
  }
`;

export interface IconCircleButtonProps {
  onClick: () => void;
  icon: "back" | "forward" | "replay";
  variant?: "primary" | "secondary";
  ariaLabel: string;
  analyticsName: string;
  isOnDarkBackground?: boolean;
  analyticsSurface?: SurfaceType;
  analyticsProperties?: AnalyticsProperties;
}

const IconCircleButton = forwardRef<ButtonElement, IconCircleButtonProps>(
  (
    {
      onClick,
      icon,
      variant = "secondary",
      ariaLabel,
      analyticsName,
      isOnDarkBackground = false,
      analyticsSurface,
      analyticsProperties,
    },
    ref,
  ) => {
    let Icon;
    switch (icon) {
      case "back":
        Icon = BackIcon;
        break;
      case "forward":
        Icon = ForwardArrowIcon;
        break;
      case "replay":
        Icon = ReplayIcon;
        break;
    }

    return (
      <$Wrapper
        variant={variant}
        isOnDarkBackground={isOnDarkBackground}
        analyticsName={analyticsName}
        analyticsSurface={analyticsSurface}
        analyticsProperties={analyticsProperties}
        onClick={onClick}
        ref={ref}
      >
        <Icon title={ariaLabel} role="img" />
      </$Wrapper>
    );
  },
);
IconCircleButton.displayName = "IconCircleButton";

export default IconCircleButton;
